import { EMOJI_GROUP, EmojiGroupId, EmojiItem } from "./types";

export const RECENT_EMOJIS_STORAGE_KEY = "emojiPickerRecent";
export const MAX_RECENT_EMOJIS = 16;

export const EMOJI_GROUP_ORDER: EmojiGroupId[] = [
  EMOJI_GROUP.SMILEYS,
  EMOJI_GROUP.GESTURES,
];

export const filterEmojis = (
  emojis: EmojiItem[],
  query: string,
): EmojiItem[] => {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return emojis;

  return emojis.filter((item) => {
    if (item.name.toLowerCase().includes(normalized)) return true;
    return item.keywords.some((keyword) =>
      keyword.toLowerCase().includes(normalized),
    );
  });
};

export const groupEmojis = (emojis: EmojiItem[]) =>
  EMOJI_GROUP_ORDER.map((group) => ({
    group,
    emojis: emojis.filter((item) => item.group === group),
  })).filter((section) => section.emojis.length > 0);

export const rememberRecentEmoji = (
  emoji: string,
  recents: string[],
  max = MAX_RECENT_EMOJIS,
): string[] =>
  [emoji, ...recents.filter((item) => item !== emoji)].slice(0, max);

export const getRecentEmojis = (): string[] => {
  try {
    const raw = localStorage.getItem(RECENT_EMOJIS_STORAGE_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((item): item is string => typeof item === "string");
  } catch {
    return [];
  }
};

export const persistRecentEmoji = (emoji: string): string[] => {
  const next = rememberRecentEmoji(emoji, getRecentEmojis());
  try {
    localStorage.setItem(RECENT_EMOJIS_STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Ignore quota / private-mode failures.
  }
  return next;
};

export const resolveRecentEmojis = (
  glyphs: string[],
  catalog: EmojiItem[],
): EmojiItem[] => {
  const byEmoji = new Map(catalog.map((item) => [item.emoji, item]));
  return glyphs.flatMap((glyph) => {
    const item = byEmoji.get(glyph);
    return item ? [item] : [];
  });
};

export const insertTextAtSelection = ({
  value,
  insert,
  start,
  end,
  maxLength,
}: {
  value: string;
  insert: string;
  start: number;
  end: number;
  maxLength: number;
}): { value: string; caret: number } | null => {
  const next = `${value.slice(0, start)}${insert}${value.slice(end)}`;
  if (next.length > maxLength) return null;
  return { value: next, caret: start + insert.length };
};
